<template>
  <MainWrapper>
      <div class="companies-control-panel mb-30">
          <div class="container">
              <div class="row">
                  <div class="col-lg-12">
                      <div class="companies-control-panel-inner">
                          <router-link to="/specialist/settings" class="mr-20">
                              <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'user-circle']" />
                              <span class="dark-body-text panel-body-text">Основные настройки</span>
                          </router-link>
                          <router-link to="/specialist/settings/schedule" class="mr-20">
                              <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'cog']" />
                              <span class="dark-body-text panel-body-text">Настройки расписания</span>
                          </router-link>
                          <router-link :to="'/specialist/calendar'" class="mr-20">
                              <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'calendar-alt']" />
                              <span class="dark-body-text panel-body-text">Календарь</span>
                          </router-link>
                          <router-link to="/specialist/reservations" class="mr-20">
                              <font-awesome-icon class="mr-10 panel-icon" :icon="['fal', 'calendar-check']" />
                              <span class="dark-body-text panel-body-text">Все записи</span>
                          </router-link>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    <div class="single-master-page">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="schedule-controls mb-20">
                        <div class="button-left animated-shadow pointer round-button mr-10" @click="prevWeek">
                            <font-awesome-icon class="icon" :icon="['fal', 'angle-left']" />
                        </div>
                        <div class="button-right animated-shadow pointer round-button mr-30" @click="nextWeek">
                            <font-awesome-icon class="icon" :icon="['fal', 'angle-right']" />
                        </div>
                        <div class="input-wrapper mr-15">
                            <input v-model="teleportDay" @change="teleportSetTime" class="rounded-input" type="date" placeholder="Переход на точную дату" />
                        </div>
                        <div class="live-query-button-wrapper mr-15">
                            <Button text="Напечатать" icon="print" />
                        </div>
                        <div v-if="copyBuffer === true" class="live-query-button-wrapper">
                            <Button text="Отменить копирование" icon="ban" class="red" @click="cancelBuffer" />
                        </div>
                        <div v-if="cutBuffer === true" class="live-query-button-wrapper">
                            <Button text="Отменить перемещение" icon="ban" class="red" @click="cancelBuffer" />
                        </div>
                        <div class="live-query-button-wrapper pull-right">
                            <Button text="Живая очередь" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <ScheduleAdmin ref="calendar" v-if="specialist_slug !== ''" :services="specInfo.service" :slug="specialist_slug" :specialist="specInfo" :startDate="firstDay" />
                </div>
            </div>
        </div>
    </div>
  </MainWrapper>
</template>
<style lang="stylus" scoped>
    @import '../../styles/main.core.vars.styl';

    .spec-categories
        padding: 20px 60px 30px 20px

    .spec-categories-header
        display: flex
        .spec-count
            margin: 0 0 0 auto
            color: $gray_text

    .spec-categories-single
        display: flex
        align-items: center
        >.icon
            margin-left: auto
            font-size: 16px

    .companies-control-panel
        margin-top: -30px
        height: 56px
        background: $black_text
        .panel-body-text, .panel-icon
            color: #fff
        .panel-icon
            font-size: 16px
        &-inner
            height: 56px
            display: flex
            align-items: center
            >div
                display: flex
                align-items: center
        input
            width: 430px

    .col-lg-1
        min-height: 0

    .arr-down
        position: absolute
        bottom: -2px
        width: 0
        height: 0
        border-left: 9px solid transparent
        border-right: 9px solid transparent
        border-bottom: 9px solid $black_text
        z-index: 4
        left: 0
        right: 0
        margin: auto

    .pull-right
        margin-left: auto

    .schedule-controls
        display: flex
        align-items: center
    
</style>
<script>
    import { Component, Vue, Watch } from "vue-property-decorator";
    import MainWrapper from '@/wrappers/MainWrapper.vue';
    import Button from '@/components/Button.vue';
    import Specialist from '@/components/Specialist.vue';
    import Paginator from '@/components/Paginator.vue';
    import ScheduleAdmin from '@/components/ScheduleAdmin.vue';
    import moment from 'moment';
    import http from '@/methods/http.ts';

    @Component({
        components: {
            MainWrapper,
            Button,
            Specialist,
            Paginator,
            ScheduleAdmin
        }
    })
    export default class CompanyAdmin extends Vue {

        moment = moment;

        cutBuffer = false;
        copyBuffer = false;

        specialist_slug = '';

        specInfo = {
            rating: 0,
            categories: [],
        };

        zcolors= [];
        colors = [
            '#2F80ED',
            '#F2C94C',
            '#ddd',
            '#eee',
        ];

        cancelBuffer() {
            if (this.cutBuffer === true) {
                this.cutBuffer = false;
                this.$refs.calendar.cutBuffer = false;
            }
            if (this.copyBuffer === true) {
                this.copyBuffer = false;
                this.$refs.calendar.copyBuffer = false;
            }
        }

        nextWeek() {
            this.$refs.calendar.ordersFillData = [];
            this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
            .add(7, "d")
            .format("DD.MM.YYYY");

            let myDate = this.firstDay;
            myDate = myDate.split(".");
            this.teleportDay = myDate[2]+"-"+myDate[1]+"-"+myDate[0];
        }

        prevWeek() {
            /*
            var myDate = this.firstDay;
            myDate = myDate.split(".");
            var newDate = myDate[1]+"/"+myDate[0]+"/"+myDate[2];
            var stepDay = Math.floor(new Date(newDate).getTime() / 1000);
            myDate = moment().format("DD.MM.YYYY");
            myDate = myDate.split(".");
            var newDate = myDate[1]+"/"+myDate[0]+"/"+myDate[2];
            var todayDay = Math.floor(new Date(newDate).getTime() / 1000);

            if (stepDay <= todayDay) {
                return false;
            }
            */
            this.$refs.calendar.ordersFillData = [];
            this.firstDay = moment(this.firstDay, "DD.MM.YYYY")
            .subtract(7, "d")
            .format("DD.MM.YYYY");

            let myDate = this.firstDay;
            myDate = myDate.split(".");
            this.teleportDay = myDate[2]+"-"+myDate[1]+"-"+myDate[0];
        }

        todayDay = moment().format("YYYY-MM-DD");
        teleportDay = moment().format("YYYY-MM-DD");
        firstDay = moment().format("DD.MM.YYYY");

        teleportSetTime() {
            var myDate = this.teleportDay.split("-");
            this.$refs.calendar.ordersFillData = [];
            this.firstDay = myDate[2]+"."+myDate[1]+"."+myDate[0];
        }

        getSpecInfo() {
            http(`masters/${this.specialist_slug}`, "get", false, {}).then(r => {
                this.specInfo = r.data;
                let owner_colors = [];
                let color_palette = this.colors;
                let i = 0;
                if (this.specInfo.company) {
                    this.specInfo.company.forEach(function (element) {
                        owner_colors[element.owner] = color_palette[i];
                        i++;
                    });
                    this.zcolors = owner_colors;
                }
            });
        }

        getUserInfo() {
            http('user/info', 'get', this.$store.state.token, {}).then(r => {
                this.specialist_slug = r.data.specialist_slug;
                this.getSpecInfo();
            })
        }

        created() {
            this.getUserInfo();
        }


    }
</script>